import { render, staticRenderFns } from "./ServiceAreasDeliveryWindowPage.vue?vue&type=template&id=c501a252&scoped=true&"
import script from "./ServiceAreasDeliveryWindowPage.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasDeliveryWindowPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasDeliveryWindowPage.vue?vue&type=style&index=0&id=c501a252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c501a252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c501a252')) {
      api.createRecord('c501a252', component.options)
    } else {
      api.reload('c501a252', component.options)
    }
    module.hot.accept("./ServiceAreasDeliveryWindowPage.vue?vue&type=template&id=c501a252&scoped=true&", function () {
      api.rerender('c501a252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/DeliveryWindows/ServiceAreasDeliveryWindowPage.vue"
export default component.exports